/**
 * Trigger a browser download from a base64-encoded payload. Used by the catalog
 * Publish screen to download the completed Nordstrom master-template file that
 * the tRPC `generateTemplate` mutation returns as base64 (no separate REST route).
 */

/** Decode a base64 string to raw bytes. */
export function base64ToBytes(base64: string): Uint8Array {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

/** Decode a base64 payload and trigger a browser download of the given file. */
export function downloadBase64(base64: string, filename: string, mimeType: string): void {
  const blob = new Blob([base64ToBytes(base64)], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
}
